import { gql } from '@apollo/client';
import { STAKEHOLDER_FIELDS } from 'domain/shared/newProject/graphql/stakeholdersFragments';

export const GET_PROJECT_STAKEHOLDERS = gql`
  query GetProjectStakeholders($id: ID!) {
    baseProject(id: $id) {
      id
      stakeholders {
        ${STAKEHOLDER_FIELDS}
      }
    }
  }
`;
